import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'cp-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.less']
})
export class ValidationErrorComponent {
  @Input()
  errors: string[] | object | string | UntypedFormControl;

  @Input()
  validate: boolean;

  @Input()
  collapseMargin = true;

  getLocalizedError(error: string) {
    return error.startsWith('Errors.') ? error : `Errors.${error}`;
  }

  get errorKeys(): string[] | undefined {
    if (!this.errors) {
      return undefined;
    }

    if (this.errors instanceof Array) {
      return this.errors;
    }

    if (this.errors instanceof UntypedFormControl) {
      return (this.errors.errors && Object.keys(this.errors.errors)) || undefined;
    }

    if (typeof this.errors === 'object') {
      return Object.keys(this.errors);
    }

    return [this.errors];
  }
}
